<template>
  <div>
    <spotlight-product-list :product-list="productList">
      <template v-slot="slotProps">
        <spotlight-product-card
          :title="getProductContent(slotProps.product).title"
          :text="getProductContent(slotProps.product).text"
          :path="`highlights/${slotProps.product.internalName}`"
          @click.native="trackClick($event, `highlights.${slotProps.product.internalName}`)"
        >
          <template v-slot:product-logo v-if="highlightsProductDataMap[slotProps.product.internalName].logo">
            <img
              :src="require(`@/assets/${highlightsProductDataMap[slotProps.product.internalName].logo}`)"
              class="product-logo"
              width="80"
              height="16"
            />
          </template>
          <template v-slot:product-icon>
            <font-awesome-icon
              class="text-primary"
              :icon="['far', `${highlightsProductDataMap[slotProps.product.internalName].icon}`]"
              :style="{ marginLeft: '5px' }"
            ></font-awesome-icon>
          </template>
        </spotlight-product-card>
      </template>
    </spotlight-product-list>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import log from '@/services/log';
import { spotlightMixin } from '@/mixins';

const SpotlightProductList = () => import('@/modules/spotlight/components/SpotlightProductList.vue');
const SpotlightProductCard = () => import('@/modules/spotlight/components/SpotlightProductCard.vue');

export default {
  name: 'Highlights',
  mixins: [spotlightMixin],
  components: {
    SpotlightProductList,
    SpotlightProductCard,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('spotlight', ['getSpotlightCategories']),
    productList() {
      return (
        this.getSpotlightCategories.find(
          payload => payload.category === this.enums.SpotlightConstants.categories.HIGHLIGHTS
        )?.spotlights || []
      );
    },
    highlightsProductDataMap() {
      return {
        [this.enums.SpotlightConstants.internalNames.siriusXm['VEHICLE-PROGRAM']]: {
          icon: 'volume',
          logo: 'sxm-logo-blue.svg',
        },
        [this.enums.SpotlightConstants.internalNames.autoverify['NEW-LISTING']]: {
          icon: 'stars',
          logo: null,
        },
        [this.enums.SpotlightConstants.internalNames.autoverify['LOW-MILEAGE']]: {
          icon: 'tachometer-slow',
          logo: null,
        },
        [this.enums.SpotlightConstants.internalNames.autoverify['PRICE-REDUCTION']]: {
          icon: 'arrow-alt-circle-down',
          logo: null,
        },
        [this.enums.SpotlightConstants.internalNames.autoverify['HIGH-SAFETY-RATING']]: {
          icon: 'shield-check',
          logo: null,
        },
        [this.enums.SpotlightConstants.internalNames.autoverify['GETTING-NOTICED']]: {
          icon: 'fire',
          logo: null,
        },
        [this.enums.SpotlightConstants.internalNames.autoverify['GREAT-DEAL']]: {
          icon: 'badge-dollar',
          logo: null,
        },
      };
    },
  },
  methods: {
    trackClick(e, spotlight) {
      // Analytics tracking
      const payload = {
        elementInteractedWith: `spotlight.${spotlight}.click`,
      };
      this.$store.dispatch('metrics/logModalInteraction', payload).catch(error => {
        log('Error in logging interaction', error);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.product-logo {
  margin-bottom: 16px;
}
</style>
